export default __webpack_public_path__ + "76e0623e7bdf3296a8b8549fd6ab0f60.glb";